import React, { useId } from 'react';
import { Button, ButtonType } from "components/common/Button.component";
import { PencilIcon, Trash2Icon } from "lucide-react";
import { ICON_SIZE } from "components/common/constants";

export const EditDeleteButtons = (props) => {

    // Rendered once per row in several tables, so each instance needs a unique tooltip id.
    // useId() gives a stable per-instance id (colons stripped so it stays a clean DOM id).
    const baseId = useId().replace(/:/g, "");

    return (
        <div className={"d-flex gap-8 py-3 align-self-center"}>
            <Button type={ButtonType.GHOST}
                    iconOnly={true}
                    icon={<PencilIcon size={ICON_SIZE.MEDIUM}/>}
                    onClick={props.editCallback}
                    disabled={props.disabled}
                    tooltip={{ id: `${baseId}-edit-tooltip`, content: () => props.translate("workflows.edit") }}
            />
            <Button type={ButtonType.GHOST}
                    iconOnly={true}
                    icon={<Trash2Icon size={ICON_SIZE.MEDIUM}/>}
                    onClick={props.deleteCallback}
                    disabled={props.disabled}
                    tooltip={{ id: `${baseId}-delete-tooltip`, content: () => props.translate("workflows.delete") }}
            />
        </div>
    )
};

export const SaveCancelButtons = (props) => {

    return (
        <div className={"d-flex gap-8 py-3 align-self-center"}>
            <Button type={ButtonType.SECONDARY}
                    onClick={props.saveCallback}
                    disabled={props.saveDisabled}
                    text={props.translate("workflowDetails.save")}
            />
            <Button type={ButtonType.SECONDARY}
                    onClick={props.cancelCallback}
                    text={props.translate("roles.cancel")}
            />
        </div>
    )
};